import * as Types from '../../../../graphql-types'

import { gql } from '@apollo/client'
import { ContentDetails_Tag_ContentReferenceFragmentFragmentDoc } from '../../../../services/yi/queries/ContentDetailsTagContentReferenceFragment.generated'
export type YiTagGroup_ContentFragmentFragment = {
  __typename?: 'Content'
  id?: string | null
  contentId?: number | null
  title?: string | null
  contentType?: string | null
  published?: boolean | null
  publishedAtDate?: any | null
  path?: string | null
  language?: string | null
  yiContentType?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  yiTagsRelatedToGroup?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentFrom?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
}

export const YiTagGroup_ContentFragmentFragmentDoc = gql`
  fragment YITagGroup_ContentFragment on Content {
    id
    contentId
    title
    contentType
    published
    publishedAtDate
    path
    language
    yiContentType: contentReferencesFrom(types: "yi-content-type") {
      ...ContentDetails_Tag_ContentReferenceFragment
    }
    yiTagsRelatedToGroup: contentReferencesTo(types: "yi-tag-group") {
      id
      sortKey
      contentReferenceType {
        type
      }
      contentFrom(language: ["en", "_primary"]) {
        id
        titleGroupId
        title
        contentId
        contentType
        published
      }
    }
  }
  ${ContentDetails_Tag_ContentReferenceFragmentFragmentDoc}
`
